export enum UserLogStatisticsConstants {
  GET_ALL_SUCCESS = 'UserLogStatisticsConstants_GET_ALL_SUCCESS',
  CLEAR_LIST = 'UserLogStatisticsConstants_CLEAR_LIST',
  ERROR = 'UserLogStatisticsConstants_ERROR'
}
